import _ from "lodash";
import { GridApi } from "ag-grid-community";
import { format } from "lib/globalize-util";
import { IDetailsTotal, IRowData } from "components/shipment-review/types";
import { buildItemTotals } from "components/shipment-review/helpers/buildItemTotals";
import type { IOrderCurrency } from "types/cart/shipment-review";

export const setDetailGridRowTotals = (api: GridApi, currency: IOrderCurrency): void => {
    const rowData: IRowData[] = [];
    api.forEachNode((node) => {
        rowData.push(node.data);
    });
    if (rowData.length <= 1) {
        return;
    }

    const filteredRowData = api.getRenderedNodes().map((row) => row.data);
    const pinnedBottomData: IDetailsTotal[] = [];
    if (filteredRowData.length && filteredRowData.length !== rowData.length) {
        pinnedBottomData.push({ headerName: format("Filtered"), ...buildItemTotals(filteredRowData, currency) });
    }
    pinnedBottomData.push(buildItemTotals(rowData, currency));

    if (_.some(pinnedBottomData, (row, idx) => !_.isEqual(row, api.getPinnedBottomRow(idx)?.data))) {
        api.setPinnedBottomRowData(pinnedBottomData);
    }
};
